<template>
  <BaseDialogForm
    v-model="showCompanyConfigForm"
    title="Company Configuration"
    maxWidth="60vw"
    :nonFieldErrors="formErrors.non_field_errors"
  >
    <template #content>
      <v-form v-model="isValid" ref="companyConfig">
        <v-row class="ma-0">
          <v-col>
            <SelectField
              v-model="companyConfig.theme"
              label="Theme*"
              name="theme"
              :itemsList="themeList"
              :rules="[(val) => !!val || 'Theme is required']"
              hide-details="auto"
              item-text="name"
              item-value="id"
              :error-messages="formErrors.theme"
              @input="delete formErrors.theme"
            />
          </v-col>
          <v-col>
            <InputField
              type="number"
              name="contact_number"
              v-model="companyConfig.contact_number"
              label="Contact Number"
              :required="true"
              :error-messages="formErrors.contact_number"
              @input="delete formErrors.contact_number"
            />
          </v-col>
          <v-col>
            <InputField
              v-model="companyConfig.address"
              label="Address"
              name="address"
              :required="true"
              :error-messages="formErrors.address"
              @input="delete formErrors.address"
            />
          </v-col>
          <v-col>
            <InputField
              v-model="companyConfig.website"
              label="Website"
              name="website"
              :error-messages="formErrors.website"
              @input="delete formErrors.website"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #actions>
      <v-btn
        color="primary"
        depressed
        @click="submitForm()"
        :disabled="!isValid"
      >
        Submit
      </v-btn>
    </template>
  </BaseDialogForm>
</template>

<script>
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import { bus } from "@/main";
export default {
  emits: ["reloadWindow"],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showCompanyConfigForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      formErrors: {},
      companyConfig: {},
      isValid: true,
      themeList: [],
    };
  },
  watch: {
    value(val) {
      if (val) {
        let obj = { ...this.$helper.getUserDetailsLocalStorage() };
        obj = {
          ...obj.company_details,
          theme: obj.company_details.configuration.theme.theme,
        };
        console.log(obj);
        this.companyConfig = { ...obj };
        this.getThemeList();
      }
    },
  },
  components: {
    BaseDialogForm,
  },
  methods: {
    submitForm() {
      bus.$emit("showLoader", true);
      this.$api.company
        .updateCompanyConfiguration(this.companyConfig.company, {
          ...this.companyConfig,
        })
        .then((res) => {
          console.log(res.data);
          this.showCompanyConfigForm = false;
          this.$emit("reloadWindow");
          // bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.formErrors = err.data
          bus.$emit("showLoader", false);
        });
    },
    getThemeList() {
      bus.$emit("showLoader", true);
      this.$api.theme
        .getThemeList({ limit: "all" })
        .then((res) => {
          this.themeList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style></style>
